import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    downloadButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    loading: {
      position: "absolute",
    },
  })
);
